import { marker, MarkerStyle } from "../marker";
import {
  LookupBucket,
  RangeBucket,
  Buckets,
  Bucket,
  AutoBuckets,
} from "./type";
import { PropertyValue } from ".";
import { Enum, EnumEntry } from "@cartographerio/util";

export function lookupBucket<A>(
  value: A,
  marker: MarkerStyle,
  label?: string
): LookupBucket<A> {
  return { type: "LookupBucket", label, value, marker };
}

export function rangeBucket<A>(
  minValue: A,
  maxValue: A,
  marker: MarkerStyle,
  label?: string,
  maxInclusive?: boolean
): RangeBucket<A> {
  return {
    type: "RangeBucket",
    label,
    minValue,
    maxValue,
    maxInclusive,
    marker,
  };
}

export function autoBuckets<A = PropertyValue>(
  props: Omit<AutoBuckets<A>, "type">
): Buckets<A> {
  return {
    type: "AutoBuckets",
    ...props,
  };
}

export function standardBuckets<A = PropertyValue>(
  buckets: Bucket<A>[]
): Buckets<A> {
  return {
    type: "StandardBuckets",
    buckets,
  };
}

export function enumBuckets<A>(source: Enum<A> | EnumEntry<A>[]): Buckets<A> {
  const entries = Array.isArray(source) ? source : source.entries;

  return standardBuckets(
    entries.map((entry, index) =>
      lookupBucket(
        entry.value,
        marker.hue((360 * index) / entries.length),
        entry.label
      )
    )
  );
}

export function nullableEnumBuckets<A>(
  source: Enum<A> | EnumEntry<A>[]
): Buckets<A | null> {
  const entries = Array.isArray(source) ? source : source.entries;

  return standardBuckets([
    ...entries.map((entry, index) =>
      lookupBucket(
        entry.value,
        marker.hue((360 * index) / entries.length),
        entry.label
      )
    ),
    lookupBucket(null, marker.empty, "(blank)"),
  ]);
}
